import React from "react";
import * as styles from "./ArticleListing.module.css";
import { Image, ComponentProps, ComponentWidth } from "../../../types/index";
import { Link } from "../../elements/Link/Link";
import { KontentImageElement } from "../../elements/KontentImageElement/KontentImageElement";
import { SectionWrapper } from "../../containers/SectionWrapper";

interface Props extends ComponentProps, ComponentWidth {
  categories: {
    name: string;
    articles: {
      title: string;
      url: string;
      image?: Image;
    }[];
  }[];
}

export const ArticleListing: React.FC<Props> = ({
  categories,
  width,
  ...props
}) => {
  let classes = [styles.container];

  if (width === "contained") {
    classes.push(styles.contained);
  }

  return (
    <SectionWrapper {...props}>
      <div className={styles.wrapper}>
        <div className={classes.join(" ")}>
          {categories.map((category, idx) => (
            <div key={idx}>
              <h3>{category.name}</h3>
              <ul>
                {category.articles.map((article, idx) => {
                  return (
                    <li key={idx}>
                      <Link to={article.url}>
                        {idx === 0 && article.image?.item ? (
                          <KontentImageElement
                            layout="constrained"
                            aspectRatio={425 / 300}
                            width={425}
                            image={article?.image?.item}
                            alt={article?.image?.alt}
                          />
                        ) : null}
                        <p className={styles.title}>{article.title}</p>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
};
